const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/students-tests",
  },
  actions: {
    // O'quvchi test holatini olish (/active)
    active({ dispatch, state, rootState }, studentId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/active?${serialize({ studentId })}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    // Yangi testni boshlash (/start)
    start({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/start`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },

    // Javob yuborish (/answer)
    answer({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/answer`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },

    // Savolni o'tkazish (/skip)
    skip({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/skip`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },

    // Test natijalarini olish
    getResults({ dispatch, state, rootState }, testId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/results/${testId}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
  },
};
